import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section id="testimonials" className="py-16 bg-white" data-id="element-355">
      <div className="container mx-auto px-4" data-id="element-356">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-serif" data-id="element-357">
          REAL MEN, REAL RESULTS
        </h2>
        <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-8" data-id="element-358">
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-359">
            <div className="mb-4 flex justify-center" data-id="element-360">
              <img src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Marcus R." className="w-24 h-24 rounded-full object-cover mb-4" data-id="element-361" />
            </div>
            <div className="flex mb-4 justify-center" data-id="element-362">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-500 fill-current" size={20} data-id="element-363" />)}
            </div>
            <p className="italic mb-6" data-id="element-364">
              "I'm 43 and felt like I was running on empty for the past 5 years.
              Two months with 247Alpha and I feel like I'm 25 again. My wife
              noticed the difference before I even told her what I was taking."
            </p>
            <div className="font-bold" data-id="element-365">– Marcus R., Construction Foreman</div>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-366">
            <div className="mb-4 flex justify-center" data-id="element-367">
              <img src="https://images.unsplash.com/photo-1600486913747-55e5470d6f40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="David K." className="w-24 h-24 rounded-full object-cover mb-4" data-id="element-368" />
            </div>
            <div className="flex mb-4 justify-center" data-id="element-369">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-500 fill-current" size={20} data-id="element-370" />)}
            </div>
            <p className="italic mb-6" data-id="element-371">
              "Tried everything – TRT, energy drinks, other supplements. Nothing
              worked until 247Alpha. My morning wood is back, my lifts are going
              up, and I actually want to have sex again."
            </p>
            <div className="font-bold" data-id="element-372">– David K., IT Director</div>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-373">
            <div className="mb-4 flex justify-center" data-id="element-374">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Robert T." className="w-24 h-24 rounded-full object-cover mb-4" data-id="element-375" />
            </div>
            <div className="flex mb-4 justify-center" data-id="element-376">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-500 fill-current" size={20} data-id="element-377" />)}
            </div>
            <p className="italic mb-6" data-id="element-378">
              "As a veteran, I was skeptical of another 'miracle pill.' But
              247Alpha delivered. More energy, better sleep, and I finally feel
              like the alpha I used to be."
            </p>
            <div className="font-bold" data-id="element-379">– Robert T., Former Marine</div>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mt-16" data-id="element-380">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-381">
            The 30-Day Challenge
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-382">
            <div className="border-l-4 border-blue-500 pl-6" data-id="element-383">
              <h4 className="font-bold mb-2" data-id="element-384">Days 1-7:</h4>
              <p data-id="element-385">
                Better sleep quality, increased morning energy, subtle mood
                improvements
              </p>
            </div>
            <div className="border-l-4 border-blue-500 pl-6" data-id="element-386">
              <h4 className="font-bold mb-2" data-id="element-387">Days 8-14:</h4>
              <p data-id="element-388">
                Noticeable strength gains in the gym, improved focus and
                motivation, returning libido
              </p>
            </div>
            <div className="border-l-4 border-blue-500 pl-6" data-id="element-389">
              <h4 className="font-bold mb-2" data-id="element-390">Days 15-21:</h4>
              <p data-id="element-391">
                Visible muscle growth, fat loss around the midsection, stronger
                erections, enhanced confidence
              </p>
            </div>
            <div className="border-l-4 border-blue-500 pl-6" data-id="element-392">
              <h4 className="font-bold mb-2" data-id="element-393">Days 22-30:</h4>
              <p data-id="element-394">
                Optimized testosterone levels, peak energy throughout the day,
                restored sexual vitality, mental sharpness
              </p>
            </div>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg mt-12" data-id="element-395">
            <div className="flex flex-col md:flex-row gap-8" data-id="element-396">
              <div className="md:w-1/3" data-id="element-397">
                <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Natural testosterone optimization" className="rounded-lg shadow-md w-full h-auto" data-id="element-398" />
              </div>
              <div className="md:w-2/3" data-id="element-399">
                <h3 className="text-xl font-bold mb-4" data-id="element-400">
                  Your Body's Natural Response
                </h3>
                <p className="mb-4" data-id="element-401">
                  Unlike synthetic hormones that shut down your natural
                  production, 247Alpha works WITH your body:
                </p>
                <ol className="list-decimal pl-6 space-y-2" data-id="element-402">
                  <li data-id="element-403">
                    <span className="font-bold" data-id="element-404">Signals your brain</span> to
                    produce more luteinizing hormone
                  </li>
                  <li data-id="element-405">
                    <span className="font-bold" data-id="element-406">Activates your testes</span> to
                    increase testosterone synthesis
                  </li>
                  <li data-id="element-407">
                    <span className="font-bold" data-id="element-408">Blocks enzymes</span> that
                    convert testosterone to estrogen
                  </li>
                  <li data-id="element-409">
                    <span className="font-bold" data-id="element-410">Reduces stress hormones</span>{' '}
                    that interfere with T production
                  </li>
                  <li data-id="element-411">
                    <span className="font-bold" data-id="element-412">Provides raw materials</span>{' '}
                    your body needs for hormone optimization
                  </li>
                </ol>
                <p className="mt-4 font-bold" data-id="element-413">
                  The result? Your body learns to produce optimal testosterone
                  levels naturally, without dependency or side effects.
                </p>
                <div className="mt-6 bg-gray-800 p-4 rounded-lg flex flex-col md:flex-row items-center gap-4" data-id="element-414">
                  <div className="md:w-1/4" data-id="element-415">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha Supplement Bottle" className="w-24 h-auto mx-auto" data-id="element-416" />
                  </div>
                  <div className="md:w-3/4 text-center md:text-left" data-id="element-417">
                    <p className="text-blue-400 font-bold mb-2" data-id="element-418">
                      FOR A LIMITED TIME SAVE 50%
                    </p>
                    <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="inline-block bg-blue-800 hover:bg-blue-900 text-white px-6 py-2 rounded-md font-medium transition duration-300 w-full md:w-auto text-center" data-id="element-419">
                      Start Your Transformation
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}